/* eslint-disable max-len */
import type { SvgProps } from '@main/core-ui/src/Icon/constants/enums';
import React from 'react';

export const Pause: React.FC<SvgProps> = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.3334 15V15C12.6434 15 12.0834 14.44 12.0834 13.75V6.25C12.0834 5.56 12.6434 5 13.3334 5V5C14.0234 5 14.5834 5.56 14.5834 6.25V13.75C14.5834 14.44 14.0234 15 13.3334 15Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.66663 15V15C5.97663 15 5.41663 14.44 5.41663 13.75V6.25C5.41663 5.56 5.97663 5 6.66663 5V5C7.35663 5 7.91663 5.56 7.91663 6.25V13.75C7.91663 14.44 7.35663 15 6.66663 15Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
/* eslint-enable max-len */
